<script setup>
import { cn } from '@/lib/utils';
import { ToastAction } from 'radix-vue';
import { computed } from 'vue';

const props = defineProps({
  altText: { type: String, required: true },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
});

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});
</script>

<template>
  <ToastAction
    v-bind="delegatedProps"
    :class="
      cn(
        'inline-flex h-8 shrink-0 items-center justify-center rounded-md border border-white/20 bg-white/10 px-3 text-sm font-medium text-white transition-colors hover:bg-white/20 hover:border-white/30 focus:outline-none focus:ring-1 focus:ring-white/50 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-red-500/30 group-[.destructive]:hover:border-red-500/50 group-[.destructive]:hover:bg-red-500/20 group-[.destructive]:focus:ring-red-500/50',
        props.class
      )
    "
  >
    <slot />
  </ToastAction>
</template>
